import { memo } from 'react';
import classNames from 'classnames';
import Button from '@alltrails/shared/denali/components/Button';
import { usePageContext } from 'components/shared/Page/Page';
import * as styles from './styles/styles.module.scss';

// Careers page does not need translations
const JobsHeader = (): JSX.Element => {
  const { adminUser } = usePageContext();
  return (
    <>
      <h2 className={styles.heading}>Find your path</h2>
      <div className={classNames(styles.subHeading, { [styles.smallMargin]: adminUser })}>
        Ready for a new career adventure? Check out our open positions. We love non-traditional candidates, interesting backstories, and people who
        are here for the mission.
      </div>
      {adminUser && (
        <Button
          text="Refresh open roles"
          className={styles.adminButton}
          linkInfo={{ href: '/careers?clean_cache=true' }}
          onClick={() => {
            /* do nothing - href redirect */
          }}
          testId="careers-refresh-open-roles"
          variant="primary"
        />
      )}
    </>
  );
};

export default memo(JobsHeader);
